module.exports = __webpack_public_path__ + "static/glow-effect-4-4c1d994e10b6027b1181583d74792e2d.png";